/** Conserva cada plazo dentro de su periodicidad. */
export function mapLoanTerms(response) {
  const options = Array.isArray(response?.options) ? response.options : [];
  return options.map((option) => ({
    frequency: option?.frequency || '',
    label: option?.label || option?.frequency || '',
    terms: Array.isArray(option?.terms)
      ? option.terms.map(Number).filter((term) => Number.isFinite(term))
      : [],
    interestRate: option?.interestRate ?? null,
    commission: option?.commission ?? null,
  })).filter((option) => option.frequency);
}

export function findLoanTermOption(options, frequency) {
  return (options || []).find((option) => option.frequency === frequency) || null;
}

export function termsForFrequency(options, frequency) {
  return findLoanTermOption(options, frequency)?.terms || [];
}

/**
 * Si el plazo actual no está en la nueva periodicidad, usa el primero
 * que sí devolvió el tarifario.
 */
export function resolveTermForFrequency(options, frequency, currentTerm) {
  const terms = termsForFrequency(options, frequency);
  const numericTerm = Number(currentTerm);
  if (terms.includes(numericTerm)) return numericTerm;
  return terms.length ? terms[0] : null;
}

/** Mensual a 6 solo si el tarifario lo incluye. */
export function defaultLoanSelection(options) {
  const list = options || [];
  const mensual = findLoanTermOption(list, 'MENSUAL');
  const option = mensual || list[0];
  if (!option) return null;
  const term = option.terms.includes(6) ? 6 : option.terms[0];
  if (term == null) return null;
  return { frequency: option.frequency, term };
}

export function offerMatchesSelection(offer, selection) {
  if (!offer || !selection) return false;
  return Number(offer.offerTerm) === Number(selection.term)
    && String(offer.paymentFrequency || '') === String(selection.frequency);
}
